package com.artvending.warden

import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.fetch.RequestInit
import org.w3c.xhr.FormData

class JsHttpClient: HttpClient {
	override suspend fun sendGetRequest(url: String, cookies: Map<String, String>): String? {
		val response = window.fetch(url, RequestInit(method = "GET")).await()
		
		return response.text().await()
	}
	
	override suspend fun sendPostRequest(url: String, vararg params: Pair<String, Any?>): String? {
		val formData = FormData()
		
		params.forEach {
			formData.append(it.first, it.second?.toString() ?: "")
		}
		
		val response = window.fetch(
			url,
			RequestInit(
				method = "POST",
				body = formData
			)
		).await()
		
		return response.text().await()
	}
}